<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">充提系统</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>用户充值地址</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
  <div class="create-actions">   
      <create-address @refresh="refreshList"></create-address>
  </div>
    <el-tabs>
<!--      <el-tab-pane label="用户地址详情" name="addressList"></el-tab-pane>-->
    </el-tabs>
    <div class="page-actions">
      <el-autocomplete
        class="inline-input"
        v-model="coinType"
        :fetch-suggestions="querySearch"
        placeholder="请输入币种">
        <i
          class="el-icon-close el-input__icon"
          slot="suffix"
          @click="cleanSearchCoin"
          style="cursor:pointer;">
        </i>
      </el-autocomplete>
      <el-input placeholder="请输入用户ID" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-input placeholder="请输入用户地址" clearable v-model="address">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-col :span="4">
    <el-input placeholder="请输入地址memo" clearable v-model="memo">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
      </el-col>
      <el-col :span="4">
      <el-input placeholder="请输入地址版本" clearable v-model="version" >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      </el-col>
      <el-button @click="handleSearchResult" type="primary">搜索</el-button>
      <el-button @click="handleSearchResultClear" type="">重置</el-button>

    </div>
    <address-list @refresh="refreshList"></address-list>
  </el-card>
</div>
</template>

<script>
import './store';
import AddressList from './components/list';
import CreateAddress from './components/create';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'UserCoinAddress',
  components: {
    AddressList,
    CreateAddress
  },
  data() {
    return {
      userId: '',
      coinType: '',
      address: '',
      memo: '',
      version: ''
    };
  },
  computed: {
    ...mapState('UserCoinAddress', ['addressList', 'allCoins', 'pagination'])
  },
  methods: {
    ...mapActions('UserCoinAddress', [
      'list',
      'getAllCoins'
    ]),
    handleSearchResult(data) {
      this.list({
        userId: this.userId,
        coinType: this.coinType,
        address: this.address,
        memo: this.memo,
        version: this.version,
        ...data.pagination
      });
    },
    handleSearchResultClear(data) {
      this.userId="";
      this.coinType="";
      this.address="";
      this.memo="";
      this.version="";
      this.pagination.page=1;
      this.pagination.size=10;
      this.list({
        userId: this.userId,
        coinType: this.coinType,
        address: this.address,
        memo: this.memo,
        version: this.version,
        ...data.pagination
      });
    },
    cleanSearchCoin() {
      this.coinType = '';
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.allCoins;
      results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.allCoins;
      return (tempData) => {
        return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(tab) {
        this.changeTab(tab.name);
    },
    refreshList(data = {}) {
      this.handleSearchResult(data);
    }
  },
  created() {
    this.getAllCoins();
    this.handleSearchResultClear();
  }
};
</script>

<style lang="less" scoped>
</style>
